// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'tax-submission.page.title': 'Tax Submissions',
    'tax-submission.page.search_results': 'Search Results',
    'tax-submission.page.create.title': 'Create New Tax Submission',
    'tax-submission.page.search.title': 'Find Tax Submissions',
    'tax-submission.page.edit.title': 'Edit Tax Submission',
    'tax-submission.page.view.title': 'View Tax Submission',
    'tax-submission.page.all': 'All',

    'tax-submission.button.cancel': 'Cancel',
    'tax-submission.button.select': 'Select',
    'tax-submission.button.find': 'Find Tax Submissions',
    'tax-submission.button.search': 'Apply',
    'tax-submission.button.create': 'Create Tax Submission',
    'tax-submission.button.new': 'New Tax Submission',
    'tax-submission.button.save': 'Save Changes',
    'tax-submission.button.delete': 'Permanently Delete',
    'tax-submission.button.edit': 'Edit',
    'tax-submission.button.restore': 'Restore',
    'tax-submission.button.reset': 'Reset',

    'tax-submission.placeholder.search': 'Search tax submissions',

    'tax-submission.link.create_first_tax_submission': 'Click here to create your first tax submission',
    'tax-submission.link.tax_submissions': ' Return to Tax Submissions',
    'tax-submission.link.retry': 'Click here to retry',

    'tax-submission.checkbox.all': 'Check All',
    'tax-submission.checkbox.actions_label': 'with selected',

    'tax-submission.label.tax_return_name': 'Tax Return',

    'tax-submission.label.tax_submission_schedule_name': 'Tax Submission Schedule',

    'tax-submission.label.from__date_submitted': 'From date submitted',
    'tax-submission.label.to__date_submitted': 'To date submitted',
    'tax-submission.label.date_submitted': 'Date Submitted',

    'tax-submission.label.from__from_date': 'From from date',
    'tax-submission.label.to__from_date': 'To from date',
    'tax-submission.label.from_date': 'From Date',

    'tax-submission.label.from__thru_date': 'From thru date',
    'tax-submission.label.to__thru_date': 'To thru date',
    'tax-submission.label.thru_date': 'Thru Date',

    'tax-submission.label.from__balance_in_cents': 'From balance in cents',
    'tax-submission.label.to__balance_in_cents': 'To balance in cents',
    'tax-submission.label.balance_in_cents': 'Balance In Cents',

    'tax-submission.label.from__created_at': 'From created at',
    'tax-submission.label.to__created_at': 'To created at',
    'tax-submission.label.created_at': 'Created At',

    'tax-submission.label.from__updated_at': 'From updated at',
    'tax-submission.label.to__updated_at': 'To updated at',
    'tax-submission.label.updated_at': 'Updated At',

    'tax-submission.label.from__deleted_at': 'From deleted at',
    'tax-submission.label.to__deleted_at': 'To deleted at',
    'tax-submission.label.deleted_at': 'Deleted At',

    'tax-submission.label.status': 'Status',

    'tax-submission.sort.field_label': 'Field',
    'tax-submission.sort.direction_label': 'Direction',
    'tax-submission.sort.direction_ascending': 'Ascending',
    'tax-submission.sort.direction_descending': 'Descending',

    'tax-submission.modal.title.tax_submission_delete_permanently': 'Delete Tax Submission',
    'tax-submission.modal.title.tax_submission_restore': 'Restore Tax Submission',

    'tax-submission.modal.message.tax_submission_delete_permanently':
        'Are you sure that you want to permanently delete this tax submission? This action cannot be undone. | Are you sure that you want to permanently delete these tax submissions? This action cannot be undone.',
    'tax-submission.modal.message.tax_submission_restore': 'Are you sure that you want to restore this tax submission? | Are you sure that you want to restore these tax submissions?',

    'tax-submission.success.message.tax_submission_created': 'Your tax submission has been created',
    'tax-submission.success.message.tax_submission_updated': 'Your tax submission has been updated',
    'tax-submission.success.message.tax_submission_restored': 'Your tax submission has been restored | All selected tax submissions were restored',
    'tax-submission.success.message.tax_submission_deleted': 'Your tax submission has been permanently deleted | All selected tax submissions were permanently deleted',

    'tax-submission.error.message.tax_submission_deleted': 'This tax submission was already permanently deleted | These tax submissions were already permanently deleted',
    'tax-submission.error.message.tax_submission_restored': 'This tax submission was already restored | These tax submissions were already restored',
    'tax-submission.error.message.error_loading_page': 'Sorry, there was an error loading tax submission.| Sorry, there was an error loading tax submissions.',
};
